import { render, staticRenderFns } from "./OperatorsView.vue?vue&type=template&id=8c4e54f4"
import script from "./OperatorsView.vue?vue&type=script&lang=js"
export * from "./OperatorsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports